module.exports = __webpack_public_path__ + "static/media/cohort_logo_mobile.21b14268.PNG";